import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppMutation } from '../use-app-mutation.hook';

export const useDeleteScenarioClassConversion = () => {
  const { mutate: deleteScenarioClassConversion, isPending } = useAppMutation(
    [QueryKey.DELETE_SCENARIO_CLASS_CONVERSION],
    {
      mutationFn: ({ scenarioId, id }: { id: string; scenarioId: string }) =>
        ApiService.delete({
          endpoint: BackendRoute.SCENARIOS,
          routePath: [scenarioId, 'scenario-class-conversions', id],
        }),
    },
  );
  return { deleteScenarioClassConversion, isPending };
};
